import { render, staticRenderFns } from "./getLinkView.vue?vue&type=template&id=4bfae66b&scoped=true&"
import script from "./getLinkView.vue?vue&type=script&lang=js&"
export * from "./getLinkView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfae66b",
  null
  
)

export default component.exports